<template lang="pug">
  .coach-detail-message
    h4 MESSAGE
    multiline-text-view(
      v-if="coach.message"
      :text="coach.message"
      @click.native="handleOpenLinkInBrowser"
      v-linkified:options="{ tagName: 'span', className: 'browser-link'}"
      class="multiline-text-view"
    )
</template>

<style lang="scss" scoped>
.coach-detail-message {
  h4 {
    padding: 0;
    margin: 0;
    text-align: center;
    @extend %title;
    opacity: 0.8;
    font-size: 16px;
    letter-spacing: 4px;
    line-height: 28px;
  }

  .multiline-text-view {
    margin: 16px 0;
    padding: 0;
    word-break: break-all;
  }
}
</style>

<script>
import MultilineTextView from '@/components/molecules/MultilineTextView'
import BridgeSwift from '@/components/mixins/BridgeSwift'

export default {
  components: {
    MultilineTextView,
  },
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  mixins: [BridgeSwift],
  methods: {
    handleOpenLinkInBrowser(e) {
      if (e.target.className.includes('browser-link')) {
        this.postMessageToSwift('didTapOpenOnBrowser', e.target.innerText)
      }
    },
  },
}
</script>
